const default_state = () => {
    return {
        pixels_keys: [],
        pixels_key: [
            null
        ],
        pixels_value: [
            null
        ]
    }
}

export default default_state